let body = $('body')
let errorClass = 'has-error'
let loaderClass = 'spinner-loader'
let loadingClass = 'loading'
let fileConfig = {
  maxFileSize: 5000 * 1000,
  maxFileSizeErroMessage: 'Bildes svars nevar pārsniegt 5MB. Lūdzu, mēģiniet vēlreiz!',
  allowedFileTypes: ['jpeg', 'png', 'jpg'],
  allowedFileTypesErrorMessage: 'Faila tips nav atļauts. Atļautie failu tipi - jpeg, png, jpg',
  chooseFromDefaultErrorMessage: 'Izvēlies vienu no cover bildēm',
}

let formDefaultImageInput = $('[name="default_image"]')

function clearForm(form) {
  form.find('.form-field input').each(function (e){
    $(this).val('')
  })

  form.find('.form-field textarea').each(function (e){
    $(this).val('')
  })

  form.find('.selected').removeClass('selected')
  form.find('.written').removeClass('written')
}

function isValidForm(form, show_errors) {

  let errors = 0
  let fields = form.find('.form-field')
  let customImageField = form.find('.form-field-images')

  fields.each(function (k, v){
    if(!isValidFormField($(this), show_errors)) {
      errors += 1
    }
  })

  if(!isValidCustomImage(customImageField, show_errors)) {
    errors += 1
  }

  return errors === 0

}

function isValidFormField(field, show_errors) {

  if(show_errors) {
    field.removeClass(errorClass)
  }


  let validField = true
  let input = field.find('[data-required]')

  if(input.length) {
    if(input.val().length === 0) {
      validField = false
      input.removeClass('written')
    } else {
      input.addClass('written')
    }
  }

  if(!validField && show_errors) {
    field.addClass(errorClass)
  }

  return validField

}

function isValidCustomImage(field, show_errors) {

  if(show_errors) {
    field.removeClass(errorClass)
  }

  let customImage = field.find('[type="file"]')
  let defaultImage = formDefaultImageInput.val()

  let valid = parseInt(defaultImage) > 0 || !isValidFile(customImage[0]).has_error

  if(!valid && show_errors) {
    field.addClass(errorClass)
  }

  return valid

}

function buttonLoader(button, show) {
  let loader = button.find('.' + loaderClass)
  show ? loader.addClass(loadingClass) : loader.removeClass(loadingClass)
}

function isValidFile(input) {

  let file = input.files ? input.files[0] : null
  let response = {
    has_error: false,
    error_message: '',
    file_name: '',
    file_src: ''
  }

  if(file) {

    let fileName = file.name
    let fileSize = file.size
    let fileType = fileName.split('.').pop().toLowerCase();

    response.file_name = fileName

    if($.inArray(fileType, fileConfig.allowedFileTypes) === -1) {
      response.has_error = true
      response.error_message += fileConfig.allowedFileTypesErrorMessage + ' '
    }

    if(fileSize > fileConfig.maxFileSize) {
      response.has_error = true
      response.error_message += fileConfig.maxFileSizeErroMessage + ' '
    }

  } else {
    response.error_message += fileConfig.chooseFromDefaultErrorMessage + ' '
    response.has_error = true
  }

  return response

}

function updateInputFileImage(image, imagePlaceholder, isBackground) {

  if (image.files && image.files[0]) {
    let reader = new FileReader();

    reader.onload = function(e) {

      if(isBackground) {
        let style = 'background-image:url(' + e.target.result + ');background-size:cover;background-position:center;background-repeat:no-repeat;'
        imagePlaceholder.attr('style', style)
      } else {
        imagePlaceholder.attr('src', e.target.result)
      }

    }

    reader.readAsDataURL(image.files[0]);
  }

}

function addCustomImage(container)
{
  container.find('.add-image').addClass('d-none')
  container.find('.edit-image').removeClass('d-none')
  container.find('.selected').removeClass('selected')
}

function removeCustomImage(container)
{
  container.removeClass('has-error')
  container.find('.edit-image').addClass('d-none')
  container.find('.add-image').removeClass('d-none')
  container.find('[type="file"]').val()
}

function setFormDefaultImage(button) {
  formDefaultImageInput.val(button.attr('data-image-id'))
}

function removeFormDefaultImage() {
  formDefaultImageInput.closest('.form-field').find('.selected').removeClass('selected')
  formDefaultImageInput.val('')
}

function enableSubmitButton(field)
{
  let form = field.closest('form')
  let isValid = isValidForm(form, false)
  form.find('[type="submit"]').prop('disabled', !isValid)
}

body.on('keyup', '.user-story-text textarea', function (e){
  let counterHtml = $(this).closest('.form-field').find('.letter-count')
  counterHtml.text($(this).val().length)
})


body.on('keyup change', '[data-required]', function (e){
  let field = $(this).closest('.form-field')

  enableSubmitButton(field)
  isValidFormField(field, true)

})

body.on('click', '.js-select-story-image', function (e){
  e.preventDefault()
  let field = $(this).closest('.form-field')
  $('.js-select-story-image').removeClass('selected')
  $(this).addClass('selected')

  setFormDefaultImage($(this))
  enableSubmitButton(field)
  removeCustomImage(field)
})

body.on('change', '#customImage', function (e){

  let image = isValidFile(this)
  let field = $(this).closest('.form-field-images')
  let error = field.find('.form-error')

  field.removeClass(errorClass)
  removeFormDefaultImage()

  if(!image.has_error) {

    updateInputFileImage(this, $('.update-user-image'), true)

    addCustomImage(field)

  } else {
    removeCustomImage(field)
    error.text(image.error_message)
    field.addClass(errorClass)


  }

  enableSubmitButton(field)

})



export { isValidFormField, isValidForm, buttonLoader, clearForm }